import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api";

/* Admin banner for the automated starter flow (Salem 2026-08-10): background checks that have
   finished and need the 2-minute review, starters held back because a check isn't clear, and
   contracts that arrived without a candidate email.

   Same manners as the probation banner: it comes from the server, so ✕ only hides it until
   tomorrow — it returns until someone actually reviews the case. Non-admins never see it. */

const DISMISS_KEY = "repiq_onboarding_banner_dismissed";

export default function OnboardingBanner() {
  const navigate = useNavigate();
  const [cases, setCases] = useState([]);
  const [hidden, setHidden] = useState(() => {
    try { return localStorage.getItem(DISMISS_KEY) === new Date().toISOString().slice(0, 10); }
    catch { return false; }
  });

  useEffect(() => {
    let live = true;
    const load = () => api.get("/api/v1/hr/onboarding/pending")
      .then((r) => { if (live) setCases(r?.cases || []); }).catch(() => {});
    load();
    const t = setInterval(load, 10 * 60 * 1000);
    return () => { live = false; clearInterval(t); };
  }, []);

  if (!cases.length || hidden) return null;
  const held = cases.filter((c) => c.state === "held" || c.state === "needs_details");
  const tone = held.length ? "var(--red)" : "var(--green)";
  const first = cases[0];
  const more = cases.length - 1;
  const line = first.state === "held" ? `${first.name} is held — ${first.holdReason}`
    : first.state === "needs_details" ? `${first.name || "A signed contract"} arrived without a candidate email`
    : `${first.name} — checks complete${first.zinc?.result ? `, ${first.zinc.result}` : ""} · profile pre-filled`;

  const dismiss = () => {
    try { localStorage.setItem(DISMISS_KEY, new Date().toISOString().slice(0, 10)); } catch { /* ignore */ }
    setHidden(true);
  };

  return (
    <div style={{
      background: `color-mix(in srgb, ${tone} 12%, var(--surface))`,
      borderBottom: `2px solid ${tone}`, padding: "8px 16px",
      display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", fontSize: 12.5,
    }}>
      <span style={{ fontSize: 16 }}>{held.length ? "⛔" : "✅"}</span>
      <span style={{ flex: 1, minWidth: 260 }}>
        <b>{line}</b>
        {more > 0 && <span className="muted"> · and {more} other starter{more === 1 ? "" : "s"} waiting on a review</span>}
        <span className="muted"> — a couple of minutes in People → Starters.</span>
      </span>
      <button className="btn btn-primary btn-sm" onClick={() => navigate("/people")}>Review</button>
      <button className="btn btn-ghost btn-sm" title="Hides until tomorrow — it comes back until the case is reviewed"
        onClick={dismiss}>✕</button>
    </div>
  );
}
